import { CreditCard, Delete, Edit, Print } from "@mui/icons-material";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react"
import CustomPagination from "../../../../../components/custom-pagination/CustomPagination";
import { CASTE_CODES, FEMALE, JESTHANAGARIK_SEWA, MALE, NO_RECORDS_FOUND } from "../../../../../utils/constants";
import { AppUtils } from "../../../../../utils/appUtils";
import { AppMisc } from "../../../../../misc/appMisc";
import { NEW_PATIENT, OTHER, PREVIOUS_PATIENT } from "../../../../../utils/constants/forms";
import ReactToPrint from "react-to-print";

const JesthaNagarikaSewaRegister = ({ totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      setMainRegisterData(props.tableData)
    }
  }, [props.tableData])
  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => tableRef.current}
      />
      <TableContainer classes={{ root: "fixed-head-table-container" }} ref={tableRef} >
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Jestha-Nagarik">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell rowSpan={4}>क्र.सं.</TableCell>
              <TableCell rowSpan={4}>दर्ता मिति </TableCell>
              <TableCell colSpan={2}>दर्ता नम्बर </TableCell>
              <TableCell colSpan={2}>सेवाग्राहीको</TableCell>
              <Tooltip title=
                {
                  <>
                    {CASTE_CODES.map(caste => (
                      <Typography key={caste.value} variant="caption"> {caste.label} </Typography>
                    ))}
                  </>
                }
                placement="top"
                arrow
              >
                <TableCell rowSpan={4}>जाती कोड</TableCell>
              </Tooltip>
              <TableCell colSpan={3}>उमेर</TableCell>
              <TableCell colSpan={5}>ठेगाना</TableCell>
              <TableCell rowSpan={2}>राष्ट्रिय परिचयपत्र नम्वर</TableCell>
              <TableCell rowSpan={2}>सम्पर्क नम्बर</TableCell>
              <TableCell rowSpan={2}>नसर्ने रोग भएमा उल्लेख गर्ने</TableCell>
              <TableCell rowSpan={2}>प्रयोगशाला परीक्षण</TableCell>
              <TableCell rowSpan={2}>ज्येष्ठनागरिक सेवा</TableCell>
              <TableCell colSpan={2}>प्रेषण भई</TableCell>
              <TableCell rowSpan={2} className="print-none">सम्पादन</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>पहिलो पटक</TableCell>
              <TableCell>थप पटक</TableCell>
              <TableCell>नाम</TableCell>
              <TableCell>थर</TableCell>
              <TableCell>महिला</TableCell>
              <TableCell>पुरुष</TableCell>
              <TableCell>अन्य</TableCell>
              <TableCell>जिल्ला</TableCell>
              <TableCell>नगर/गाउँपालिका</TableCell>
              <TableCell>वडा नं.</TableCell>
              <TableCell>टोल</TableCell>
              <TableCell>अन्य मुलुक</TableCell>
              <TableCell>आएको संस्थाको नाम</TableCell>
              <TableCell>गएको संस्थाको नाम</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            {mainRegisterData.length > 0 ? (
              mainRegisterData?.map((row, index) => (
                <TableRow>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                  <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                  <TableCell>{row?.patientType === NEW_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                  <TableCell>{row?.patientType === PREVIOUS_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                  <TableCell>{row?.patientFirstName || "-"}</TableCell>
                  <TableCell>{row?.patientLastName || "-"}</TableCell>
                  <TableCell>{row?.casteCode && AppUtils.replaceWithNepaliDigit(row.casteCode) || "-"}</TableCell>
                  <TableCell>{row?.gender === FEMALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                  <TableCell>{row?.gender === MALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                  <TableCell>{row?.gender === OTHER ? AppUtils.replaceWithNepaliDigit(row?.age) : "-"}</TableCell>
                  <TableCell>{row?.district && AppMisc.getDistrictName(row?.district)}</TableCell>
                  <TableCell>{row?.palikaName && AppMisc.getMunicipalityName(row?.palikaName)}</TableCell>
                  <TableCell>{row?.wardNumber && AppUtils.replaceWithNepaliDigit(row?.wardNumber)}</TableCell>
                  <TableCell>{row?.gaunOrTole || "-"}</TableCell>
                  <TableCell>{row?.otherCountry || "-"}</TableCell>
                  <TableCell>{row?.nid || "-"}</TableCell>
                  <TableCell>{row?.phoneNumber && AppUtils.replaceWithNepaliDigit(row?.phoneNumber)}</TableCell>
                  <TableCell>{row?.nonCommunicableDiseaseTest || "-"}</TableCell>
                  <TableCell>{row?.labTest || "-"}</TableCell>
                  <TableCell>{AppMisc.findLabelFromValue(JESTHANAGARIK_SEWA, row?.jesthaNagarikSewa || "-")}</TableCell>
                  <TableCell>{row?.referredIn || "-"}</TableCell>
                  <TableCell>{row?.referredOut || "-"}</TableCell>
                  <TableCell className="print-none">
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <IconButton aria-label="edit">
                        <Edit fontSize="small" onClick={() => props.onEditRow(row.id)} />
                      </IconButton>
                      {/* <Tooltip title="स्वास्थ्य सेवा कार्ड हेर्न यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <CreditCard fontSize="small" />
                        </Tooltip> */}
                      <Tooltip title="मूल दर्ता रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                        <IconButton >
                          <Delete fontSize="small" color='secondary' onClick={() => props.deleteRow(row.id)} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan="41" size="medium">{NO_RECORDS_FOUND}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        count={totalSize}
      />
    </>
  )
}

export default JesthaNagarikaSewaRegister;